import { forwardRef, type SVGProps } from 'react';

export const AmountCheckSuccessIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function AmountCheckSuccessIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_10940)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <g clipPath="url(#clip1_1621_10940)">
          <path
            d="M21.6 26.4688H21.5993C21.5993 25.8683 21.6495 26.1448 18.4099 19.733C17.748 18.4234 15.8528 18.4208 15.1898 19.733C11.9227 26.1997 12.0008 25.8872 12.0008 26.4688H12C12 28.1082 14.1491 29.4375 16.8 29.4375C19.4509 29.4375 21.6 28.1082 21.6 26.4688ZM16.8 20.5312L19.5 25.875H14.1L16.8 20.5312ZM35.9993 26.4688C35.9993 25.8683 36.0495 26.1448 32.8099 19.733C32.148 18.4234 30.2528 18.4208 29.5898 19.733C26.3228 26.1997 26.4008 25.8872 26.4008 26.4688H26.4C26.4 28.1082 28.5491 29.4375 31.2 29.4375C33.8509 29.4375 36 28.1082 36 26.4688H35.9993ZM28.5 25.875L31.2 20.5312L33.9 25.875H28.5ZM31.8 30.625H25.2V19.687C26.0816 19.3052 26.7435 18.5188 26.9396 17.5625H31.8C32.1315 17.5625 32.4 17.2968 32.4 16.9688V15.7812C32.4 15.4532 32.1315 15.1875 31.8 15.1875H26.3865C25.839 14.4705 24.9784 14 24 14C23.0216 14 22.161 14.4705 21.6135 15.1875H16.2C15.8685 15.1875 15.6 15.4532 15.6 15.7812V16.9688C15.6 17.2968 15.8685 17.5625 16.2 17.5625H21.0604C21.2565 18.5184 21.918 19.3052 22.8 19.687V30.625H16.2C15.8685 30.625 15.6 30.8907 15.6 31.2188V32.4062C15.6 32.7343 15.8685 33 16.2 33H31.8C32.1315 33 32.4 32.7343 32.4 32.4062V31.2188C32.4 30.8907 32.1315 30.625 31.8 30.625Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1621_10940">
          <rect fill="white" height="48" width="48" />
        </clipPath>
        <clipPath id="clip1_1621_10940">
          <rect
            fill="white"
            height="19"
            transform="translate(12 14)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
});
